import { BaseToast } from "./BaseToast";
import { ToastProps } from "./types";

export const SuccessToast = ({ children, ...rest }: ToastProps) => {
  return (
    <BaseToast {...rest} toastType="success">
      {children}
    </BaseToast>
  );
};
